import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "recommend-page-list-area" }
const _hoisted_2 = { class: "recommend-page-top-view" }
const _hoisted_3 = { class: "recommend-page-top-view-area" }
const _hoisted_4 = { class: "commonTextBodyStrong recommend-page-title-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonRecipeList = _resolveComponent("CommonRecipeList")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_CommonRecipeList, {
        recipes: _ctx.recommendRecipes,
        onSelectRecipe: _ctx.selectRecipe
      }, null, 8, ["recipes", "onSelectRecipe"])
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getTitle()), 1)
      ])
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: 9,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      negativeLabel: _ctx.ERROR_BUTTON_LABEL,
      onNegativeClick: _ctx.closeError
    }, null, 8, ["isShowDialog", "title", "message", "negativeLabel", "onNegativeClick"])
  ]))
}